import { Swiper } from 'swiper';
import { FreeMode, Navigation, Pagination } from 'swiper/modules';
import { gsap } from "gsap";
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {

  const recipients = document.querySelector('#recipients');

  const recipientsCarousel = () => {
    new Swiper(recipients, {
      modules: [FreeMode],
      freeMode: true,
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 500
    });
  }

  const liczby = document.querySelector('#liczby');

  const liczbyCarousel = () => {
    const anim = function () {
      const section = document.querySelector("#liczby");
      if (!section) return;

      const slide = document.querySelector("#slide-1");
      if (!slide) return;

      const inner = slide.querySelector(".bg-gray");
      if (!inner) return;

      gsap.fromTo(
        inner,
        { rotation: 0 },
        {
          rotation: 6,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            endTrigger: slide,
            start: "top bottom",
            end: "center center",
            scrub: 0.3,
            invalidateOnRefresh: true
          }
        }
      );
    }

    new Swiper(liczby, {
      modules: [FreeMode],
      freeMode: true,
      slidesPerView: 3,
      spaceBetween: 48,
      speed: 500,

      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 48,
        }
      },

      on: {
        init: () => {
          anim();
        }
      }
    });
  }

  window.carousels = () => {
    recipients ? recipientsCarousel() : false;
    liczby ? liczbyCarousel() : false;
  }
}, false)
